import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { useSignups } from "Signups/state.js";
import { useFetchPriceFlag } from "Signups/stateHooks";
import { AnimatePresence } from "framer-motion";

import { useReFetchSignupListInfo } from "../SignupItem/stateHooks";

import PayNowArea from "./PayNowArea";
import PaymentsDrawer from "./PaymentsDrawer";
import { getAllUserSignupItemIDs } from "./getAllUserSignupItemIDs";
import { useCalculateNumberOfUnpaidSlots } from "./useCalculateNumberOfUnpaidSlots";
import { useFetchPaymentAmountNeeded } from "./useFetchPaymentAmountNeeded";
import useShowPayNowArea from "./useShowPayNowArea";

export default function SignupPayment({ footerRef }) {
  const [state] = useSignups();
  const [showDrawer, setShowDrawer] = useState(false);
  const [successfulPayment, setSuccessfulPayment] = useState(false);

  const signupListId = state?.currentSignupList?.ID;
  const fundId = state?.currentSignupList?.fundIt?.fund?.ID || 3;
  const emailPhone = state.user?.isAnonymousUser && state.user?.emailOrPhone;
  const { entity, entityPlural } =
    state.currentSignupList.signupListVerbs || {};
  const isSuggestedDonation =
    state.currentSignupList?.fundIt?.isSuggestedDonation;
  const showConfetti = Boolean(state.currentSignupList?.options?.showConfetti);
  const [fetchPriceFlag, setFetchPriceFlag] = useFetchPriceFlag();

  let history = useHistory();

  const fetchPaymentAmount = useFetchPaymentAmountNeeded();
  useEffect(() => {
    if (fetchPriceFlag) {
      fetchPaymentAmount();
      setFetchPriceFlag(false);
    }
  }, [fetchPaymentAmount, fetchPriceFlag, setFetchPriceFlag]);

  const unpaidSlots = useCalculateNumberOfUnpaidSlots();

  const { paymentAmountNeeded } = state;

  const userSignupItemIDs = getAllUserSignupItemIDs(state.userSignupItems);
  const url = `give/${fundId}?signupListID=${signupListId}&amount=${paymentAmountNeeded}${
    emailPhone ? `&emailPhone=${emailPhone}` : ""
  }&userSignupItemIDs=${userSignupItemIDs}${
    isSuggestedDonation ? "&isSuggestedDonation=true" : ""
  }`;

  const handleClick = () => {
    const pathName = window.location.pathname.replace(/\/$/, "");
    history.push(`${pathName}/${url}`);
    setShowDrawer(true);
  };

  const closeDrawer = () => {
    history.goBack();
    setShowDrawer(false);
    setSuccessfulPayment(false);
  };

  const reFetchSignupListInfo = useReFetchSignupListInfo();

  const { showPayNowArea } = useShowPayNowArea();

  useEffect(
    function preventScrollOnBodyWhenDrawerIsOpen() {
      if (showDrawer) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "unset";
      }
    },
    [showDrawer]
  );

  return (
    <AnimatePresence>
      {showPayNowArea ? (
        <PayNowArea
          key="payment-footer"
          handleClick={handleClick}
          amount={paymentAmountNeeded}
          unpaidSlots={unpaidSlots}
          entity={entity}
          entityPlural={entityPlural}
          footerRef={footerRef}
        />
      ) : null}

      <PaymentsDrawer
        key="signup-payments-drawer"
        show={showDrawer}
        onClose={closeDrawer}
        url={url}
        reFetchSignupListInfo={reFetchSignupListInfo}
        postData={{
          signupListID: signupListId,
          amount: paymentAmountNeeded,
          emailPhone,
          userSignupItemIDs,
        }}
        fundID={fundId}
        successfulPayment={successfulPayment}
        setSuccessfulPayment={setSuccessfulPayment}
        isSuggestedDonation={isSuggestedDonation}
        hideConfetti={!showConfetti}
      />
    </AnimatePresence>
  );
}
